<template>
<div >

	<Navbar></Navbar>
	<div class="main-content">
		<Loader :show="loading"></Loader>
		<div class="container" v-if="!loading">
			
			<div class="card mt-2">
				<div class="card-body">
		
					<div class="page-header">
						<ol class="breadcrumb">
							<li class="breadcrumb-item">GENERAL</li>
							<li class="breadcrumb-item active">Funcionarios</li>
						</ol>
						<div class="title">
							<h1>Funcionarios</h1>
						</div>
						<div class="cta">
							<button class="btn btn-sm btn-outline-secondary" @click="openModal(null)">Crear funcionario</button>
						</div>
					</div>

						
					<div class="filters-box">
						<div class="filter">
							<label>BUSCAR</label>
							<input 
								type="text" 
								class="form-control" 
								placeholder="Buscar" 
								v-model="filters.search" 
								@keyup.enter="updateFilters($event)">
						</div>
					</div>
				
					<table class="table table-clickeable">
						<tr class="table-head">
							<td>Funcionario</td>
							<td>Contacto</td>
							<td></td>
						</tr>
						
						<tr v-for="item of list" :key="item.id" @click="openModal(item.id)" >
							<td>
								{{item.name}}
							</td>
							<td >
								<div class="tc">
									<span class="text-primary">{{item.email}}</span>
									<span  v-if="item.phone">{{item.phone.national}}</span>
								</div>
							</td>
							<td>
								<span class="badge badge-warning" v-if="item.is_admin">ADMIN</span>		
							</td>
						</tr>
						
					</table>

					<div class="alert alert-info text-center" v-if="list.length==0" >No se han encontrado items</div>
					
					<vue-ads-pagination v-if="pagination"
						:total-items="pagination.total"
						:max-visible-pages="2"
						:items-per-page="pagination.length"
						:page="pagination.page-1"
						@page-change="pageChange"					
					></vue-ads-pagination>
				</div>
			</div>
		</div>
	</div>
	<EmployeeModal ref="employeeModal" @updated="load()"></EmployeeModal>

</div>
</template>

<script>
import gql from 'graphql-tag'
import listMixins from '@/mixins/listMixins'

import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'

import EmployeeModal from '@/views/employees/EmployeeModal'

export default {
	name: 'employees',
	components:{
		Navbar,
		Loader,
		EmployeeModal
	},
	mixins:[listMixins],
	data () {
		return {
			list:[],
			loading: true,
		}
	},
	beforeMount(){
		this.filters = this.getValidUrlParams();
		this.load();
	},
	methods:{
		load(){
			this.$apollo.query({
				query: gql`query ($first: Int!, $page: Int, $search: String) {
					users(first: $first, page: $page, search: $search) {
						paginatorInfo {
							count
							currentPage
							total
						}
						data {
							id
							name
							email
							phone{
								national
							}
							is_admin
							status							
						}
					}
				}`,
				variables: {
					page: this.pagination.page,
					first: this.pagination.length,
					search: this.filters.search,
				},
			})
			.then((data) => {
				this.list = data.data.users.data;
				this.pagination.total = data.data.users.paginatorInfo.total;
				this.loading = false
			});
		},
		openModal(id){
			this.$refs.employeeModal.open(id)
		}

	}
}


</script>

<style>

</style>
